import { defineComponent, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { queryPayRes } from "@/api/recharge";
export default defineComponent({
  name: "RechargeSuccess",
  setup() {
    const route = useRoute();
    const id = ref();
    const res = ref();
    const queryRes = () => {
      queryPayRes({
        outTradeNo: id.value
      }).then(({
        code,
        data
      }) => {
        if (code === 200) {
          res.value = JSON.stringify(data);
        }
      });
    };
    watch(() => route.query, val => {
      console.log(val);
      id.value = val.id;
      queryRes();
    }, {
      immediate: true
    });
    // 返回按钮
    // const onClickLeft = () => history.back();
    return {
      id,
      res
      // onClickLeft,
    };
  }
});